export default "__VITE_ASSET__Be2vdG0c__"